// dataResult ที่ปรับให้เป็น object
const dataResult = {
    colors: [
        { Red: 'มั่นใจ' }, // Confident
        { Blue: 'สงบ' }, // Peaceful
        { Green: 'สดใส' }, // Bright
        { Yellow: 'ร่าเริง' }, // Cheerful
        { Purple: 'สร้างสรรค์' }, // Creativity
        { Black: 'ลึกซึ้ง' }, // Profound
    ],
    tourists: [
        { Beach: 'ชอบพักผ่อน' }, // Relax
        { City: 'ชอบความตื่นเต้น' }, // Like the excitement
        { Mountain: 'สงบ' }, // Calm
        { Forest: 'สงบ' }, // Calm 
        { History: 'ชอบเรียนรู้' }, // Like learning
        { Art: 'สร้างสรรค์' }, // Creativity
    ],
    bedrooms: [
        { Simple: 'ชอบความสะดวกสบาย' }, // Like the convenience
        { Colorfull: 'ร่าเริง' }, // Cheerful
        { Woot: 'รักความอบอุ่น' }, // Love warmth
        { Vintage: 'ชอบของคลาสสิค' }, // Like the classics
        { PicUrl: 'ชอบศิลปะ' }, // Like art
        { Simple2: 'ชอบความมีประสิทธิภาพ' }, // Like efficiency
    ],
    foods: [
        { Sea: 'ชอบลองสิ่งใหม่ๆ' }, // Like trying new things
        { Asia: 'ชอบความหลากหลาย' }, // Like variety
        { Frence: 'รักความหรูหรา' }, // Love luxury
        { Italian: 'ชอบของคลาสสิค' }, // Like the classics
        { Maxican: 'ชอบรสชาติที่จัดจ้าน' }, // Like the bold flavor
        { China: 'ชอบความหลากหลาย' }, // Like variety
    ],
    houses: [
        { Modle: 'ชอบความทันสมัย' }, // Like modernity
        { Classic: 'ชอบความอบอุ่น' }, // Like warmth
        { Countryside: 'ชอบความเรียบง่าย' }, // Like simplicity
        { Scandivia: 'ชอบความสะอาดและเรียบง่าย' }, // Like cleanliness and simplicity
        { Minimal: 'ชอบความเรียบง่าย' }, // Like simplicity
        { Big: 'ชอบความหรูหรา' }, // Like luxury
    ],
    cars: [
        { Sport: 'ชอบความตื่นเต้น' }, // Like the excitement
        { Hight: 'รักความหรูหรา' }, // Love luxury
        { Electronic: 'ใส่ใจสิ่งแวดล้อม' }, // Care about the environment
        { Offroad: 'ชอบการผจญภัย' }, // Adventurous
        { Middle: 'ชอบความสะดวกสบาย' }, // Like the convenience
        { Van: 'ชอบความอบอุ่น' }, // Like warmth
    ]
};

export default dataResult;